import Vue from "vue";

export default {
    createCategoriaEmpleado(parametros) {
        return Vue.axios
            .post("catalogo/categoria_empleado", parametros)
            .then((response) => Promise.resolve(response.data))
            .catch((err) => Promise.reject(err));
    },
    updateCategoriaEmpleado(parametros) {
        return Vue.axios
            .put("catalogo/categoria_empleado", parametros)
            .then((response) => Promise.resolve(response.data))
            .catch((err) => Promise.reject(err));
    },
    getCategoriasEmpleado(parametros) {
        return Vue.axios
            .get("catalogo/categoria_empleado/find", { params: parametros })
            .then((response) => Promise.resolve(response.data))
            .catch((err) => Promise.reject(err));
    },
    getCategoriaEmpleado(id) {
        return Vue.axios
            .get("catalogo/categoria_empleado/" + id)
            .then((response) => Promise.resolve(response.data))
            .catch((err) => Promise.reject(err));
    },
    deleteCategoriaEmpleado(id) {
        return Vue.axios
            .delete("catalogo/categoria_empleado/" + id)
            .then((response) => Promise.resolve(response))
            .catch((err) => Promise.reject(err));
    },
};
